import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../../translation/translation';
import { getTypeByFilter } from '../../../../../helper/filters/get_type_by_filter';
import { getDefaultValueForFilter } from '../../../../../helper/filters/get_default_value_for_filter';
import { FilterTypes } from '../../../../../constants/filter/filter_types';
import { Filters } from '../../../../../constants/filter/filters';
import { types } from '../../../../../../_constants/product/types';
import { getSizeValueComponent } from '../../../../statusbar/mobile/current_status/size_value/get_size_value_component';
import LightboxActiveFilter from './lightBoxActiveFilter';
import LightboxActiveBooleanFilter from './lightboxActiveBooleanFilter';
import getTranslatedText from '../../../../../helper/get_translated_text';



LightboxActiveFilter.propTypes = {
    filterName: PropTypes.string.isRequired,
    filterValue: PropTypes.string.isRequired,
    onUnsetFilter: PropTypes.func.isRequired,
};

const filterSorting = [
    Filters.LOAD_INDEX,
    Filters.SPEED_INDEX,
    Filters.MANUFACTURER,
    Filters.MODEL,
    Filters.PRICE_MIN,
    Filters.PRICE_MAX,
    Filters.BUY_4_PAY_3,
    Filters.CLEARANCE,
    Filters.INSTANT_CASH,
    Filters.RUN_FLAT,
    Filters.VEHICLE_TYPE,
    Filters.QUALITY_SEGMENT_PREMIUM,
    Filters.QUALITY_SEGMENT_VALUE,
    Filters.QUALITY_SEGMENT_BUDGET,
];

function sortFilters(prev, next) {
    const prevIndex = filterSorting.indexOf(prev.value);
    const nextIndex = filterSorting.indexOf(next.value);
    return prevIndex < nextIndex ?
        -1 : prevIndex > nextIndex ?
            1 :
            0
        ;
}

const filterActiveFiltersByProductType = productType => (filter) => {
    const { key, value } = filter;
    if (productType === types.WHEEL) {
        return getDefaultValueForFilter(key) !== value && key !== 'postcode' && value !== '';
    }
    return getDefaultValueForFilter(key) !== value && value && value !== '' &&
        key !== 'postcode' &&
        key !== Filters.WIDTH &&
        key !== Filters.HEIGHT &&
        key !== Filters.DIAMETER;
};


function LightboxActiveFilters({ filterValues, filterOptions, onUnsetFilter, productType, displayDimensions }) {
    if (!Object.keys(filterValues).some((key) => filterValues[key] !== getDefaultValueForFilter(key))) {
        return null;
    }

    const filterActiveFilters = filterActiveFiltersByProductType;
    const activeFilters = Object.keys(filterValues).
        reduce((newContainer, key) => newContainer.push({ value: filterValues[key], key }) && newContainer,
            [])
        .filter(filterActiveFilters(productType))
        .sort(sortFilters);
    return (
        <div className="lightbox-overview-active-filters lightbox-overview-section">
            {(productType !== types.WHEEL) && (displayDimensions || (filterValues[Filters.WIDTH] && filterValues[Filters.HEIGHT] && filterValues[Filters.DIAMETER]))
                && <><Translation
                    translationKey="Selected Tyre size"
                    className="lightbox-overview-active-filters__headline"
                    tagName="h3"
                />
                    {getSizeValueComponent('NONE_MISSING', filterValues, displayDimensions)}
                </>}
            <Translation
                translationKey="catalog-filter-lightbox-active-filters-headline"
                className="lightbox-overview-active-filters__headline"
                tagName="h3"
            />
            {!activeFilters.length && <p
                className="vehicle-overview-active-filters lightbox-overview-active-filters__without-remove-filter"
            >{getTranslatedText('catalog-filter-lightbox-no-active-filters-headline')}</p>
            }
            {
                activeFilters.map(filter => {
                    if (getTypeByFilter(filter.key) === FilterTypes.BOOLEAN_FILTER) {
                        return (
                            <LightboxActiveBooleanFilter
                                filterName={filter.key}
                                onUnsetFilter={onUnsetFilter}
                                key={filter.key + filter.value}
                            />
                        );
                    }
                    const filterOption = filterOptions[filter.key]
                        && filterOptions[filter.key]
                            .find(option => option[0].toString() === filter.value.toString());

                    if (filterOption) {
                        return (
                            <LightboxActiveFilter
                                filterName={filter.key}
                                filterValue={filterOption[1].toString()}
                                onUnsetFilter={onUnsetFilter}
                                key={filter.key + filter.value}
                            />
                        );
                    }

                    return undefined;
                })
            }
        </div>
    );
}

LightboxActiveFilters.propTypes = {
    filterValues: PropTypes.object.isRequired,
    filterOptions: PropTypes.object.isRequired,
    onUnsetFilter: PropTypes.func.isRequired,
    productType: PropTypes.string.isRequired,
    displayDimensions: PropTypes.string
};

export { LightboxActiveFilters };
